// Limite de membros de um grupo, vindo da campanha (member_count_per_group).
// Fallback quando ausente/0 pra evitar divisão por zero / "NaN" no contador.
export const MEMBERS_FALLBACK = 256;

export const memberLimit = (campaign) =>
    campaign?.member_count_per_group > 0 ? campaign.member_count_per_group : MEMBERS_FALLBACK;
